import { useState } from 'react';

/**
 * サイドバーの開閉状態管理用カスタムフック
 */
export const useStateSideBar = () => {
	const [isSideBarOpened, setIsSideBarOpened] = useState(true); // サイドバーの状態管理

	// サイドバーを開閉するボタンを押下した際の処理
	const toggleSideBar = () => {
		setIsSideBarOpened(!isSideBarOpened);
	};

	return {
		isSideBarOpened,
		toggleSideBar,
	};
};
